import React, { useState } from "react";

const AdminLogin = ({ t, onLogin, onExit }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    const ok = onLogin(form);
    if (!ok) setError(t.invalidCredentials);
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-left">
        <div className="admin-login-brand">
          <h1 className="admin-login-brand-title">{t.adminPanel}</h1>
          <p className="admin-login-brand-desc">{t.adminLoginDesc}</p>
        </div>
        <ul className="admin-login-features">
          <li><span>📊</span> {t.dashboard}</li>
          <li><span>📝</span> {t.manageQuestions}</li>
          <li><span>📋</span> {t.viewResults}</li>
        </ul>
      </div>

      <div className="admin-login-right">
        <div className="admin-login-card">
          <div className="admin-login-card-header">
            <div className="admin-login-icon">🔐</div>
            <h2>{t.adminLogin}</h2>
            <p>{t.adminLoginSubtitle}</p>
          </div>

          <form onSubmit={handleSubmit} className="admin-login-form" autoComplete="off">
            {error && <div className="admin-login-error">{error}</div>}

            <div className="input-group">
              <label htmlFor="admin-email">{t.email}</label>
              <div className="input-with-icon">
                <span className="input-icon">✉️</span>
                <input
                  id="admin-email"
                  type="email"
                  name="email_field_unbound"
                  autoComplete="off"
                  placeholder="admin@hevmed.com"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className="input-group">
              <label htmlFor="admin-password">{t.password}</label>
              <div className="input-with-icon">
                <span className="input-icon">🔑</span>
                <input
                  id="admin-password"
                  type={showPassword ? "text" : "password"}
                  name="password_field_unbound"
                  autoComplete="new-password"
                  placeholder="••••••••"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password"
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            <button type="submit" className="btn-primary btn-lg btn-full admin-login-submit">
              {t.login}
            </button>
            <button type="button" className="btn-ghost btn-full" onClick={onExit}>
              ← {t.backToApp}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
